import { render, staticRenderFns } from "./placard_apply_for_invoice_data.vue?vue&type=template&id=21ea4e1f&scoped=true"
import script from "./placard_apply_for_invoice_data.vue?vue&type=script&lang=js"
export * from "./placard_apply_for_invoice_data.vue?vue&type=script&lang=js"
import style0 from "./placard_apply_for_invoice_data.vue?vue&type=style&index=0&id=21ea4e1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ea4e1f",
  null
  
)

export default component.exports